import { Suspense } from "react";

import { ErrorBoundary } from "@/components/error-boundary";
import { Skeleton } from "@/components/ui/skeleton";

import { CashBoxPanel } from "./cash-box-panel";
import { CashDayPanel } from "./cash-day-panel";
import type { FinanceModal } from "./types";

export function CashArea({
	date,
	onModal,
}: {
	date: string;
	onModal: (modal: FinanceModal) => void;
}) {
	return (
		<div className="flex min-w-0 flex-col gap-5">
			<ErrorBoundary key={`day:${date}`}>
				<Suspense fallback={<CashDaySkeleton />}>
					<CashDayPanel date={date} onModal={onModal} />
				</Suspense>
			</ErrorBoundary>
			<ErrorBoundary key={`cash:${date}`}>
				<Suspense fallback={<Skeleton className="h-80 w-full rounded-lg" />}>
					<CashBoxPanel date={date} onModal={onModal} />
				</Suspense>
			</ErrorBoundary>
		</div>
	);
}

function CashDaySkeleton() {
	return (
		<div className="grid gap-5">
			<Skeleton className="h-64 w-full rounded-lg" />
			<Skeleton className="h-52 w-full rounded-lg" />
			<Skeleton className="h-40 w-full rounded-lg" />
		</div>
	);
}
